import { IAdminSlice, TAdminPage } from "@/redux/slices/admin/types";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { putAdminPage } from "@/lib/api-server/admin/page/putAdminPage";

export const putPage = createAsyncThunk(
  "admin/putPage",
  async (
    {
      page,
      storeUuid,
    }: {
      page: TAdminPage;
      storeUuid: string;
    },
    { rejectWithValue },
  ) =>
    await putAdminPage(page.uuid, page, storeUuid).then((r) => {
      if (!r.success) return rejectWithValue(r.error);
      return r.data;
    })
);

const pending = (
  state: IAdminSlice,
  { meta }: { meta: { arg: TAdminPage } },
) => {
  state.pages = state.pages.map((p: TAdminPage) => {
    if (p.uuid === meta.arg.uuid) {
      return {
        ...p,
        loading: true,
      };
    }
    return p;
  });
};

const rejected = (
  state: IAdminSlice,
  { meta }: { meta: { arg: TAdminPage } },
) => {
  state.pages = state.pages.map((p: TAdminPage) => {
    if (p.uuid === meta.arg.uuid) {
      return {
        ...p,
        loading: false,
      };
    }
    return p;
  });
};

const fulfilled = (
  state: IAdminSlice,
  { payload }: { payload: TAdminPage },
) => {
  state.pages = state.pages.map((p: TAdminPage) => {
    if (p.uuid === payload.uuid) {
      return {
        ...payload,
        loading: false,
      };
    }
    return p;
  });
};

export default {
  action: putPage,
  pending,
  rejected,
  fulfilled,
};
